// extracted by mini-css-extract-plugin
export default {"page":"StorePage_page__KaPfv","divider":"StorePage_divider__PGH1Q","comingSoon":"StorePage_comingSoon__NAMBL","comingSoonCard":"StorePage_comingSoonCard__rcWzk"};